import { render, staticRenderFns } from "./SubCategoriaLista.vue?vue&type=template&id=4e894ff1&scoped=true&"
import script from "./SubCategoriaLista.vue?vue&type=script&lang=js&"
export * from "./SubCategoriaLista.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoriaLista.vue?vue&type=style&index=0&id=4e894ff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e894ff1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
